import React, {useState, useEffect} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Message from "../components/Message";
import Loader from "../components/Loader";
import FormContainer from "../components/FormContainer";
import { register } from "../actions/userActions";


function RegisterScreen() {
    const { t } = useTranslation();


    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const normalizeRedirect = (value) => {
      if (!value) return '/';
      const decoded = decodeURIComponent(value);
      return decoded.startsWith('/') ? decoded : `/${decoded}`;
    };

    const redirectQuery = new URLSearchParams(location.search).get('redirect');
    const redirect = normalizeRedirect(redirectQuery);

    const userRegister = useSelector(state => state.userRegister);
    const { loading, error, userInfo } = userRegister;


    useEffect(() => {
        if (userInfo) {
            navigate(redirect);
        }
    }, [navigate, userInfo, redirect]);


    function submitHandler(e) {
        e.preventDefault();
        if (password !== confirmPassword) {
            setMessage(t('register.passwordMismatch'));
      } else if (!phoneNumber.trim()) {
        setMessage(t('register.phoneRequired'));
        } else {
          dispatch(register(name, email, password, phoneNumber));
        }
    }

    
  return (
    <FormContainer>
      <h1>{t('register.title')}</h1>
      {message && <Message variant="danger">{message}</Message>}
      {error && <Message variant="danger">{error}</Message>}
      {loading && <Loader />}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="name">
          <Form.Label>{t('register.name')}</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder={t('register.namePlaceholder')}
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></Form.Control>
        </Form.Group>


        <Form.Group controlId="email">
          <Form.Label>{t('register.email')}</Form.Label>
          <Form.Control
            required
            type="email"
            placeholder={t('register.emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="phoneNumber">
          <Form.Label>{t('register.phone')}</Form.Label>
          <Form.Control
            required
            type="tel"
            placeholder={t('register.phonePlaceholder')}
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="password">
          <Form.Label>{t('register.password')}</Form.Label>
          <Form.Control
            required
            type="password"
            placeholder={t('register.passwordPlaceholder')}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="confirmPassword">
          <Form.Label>{t('register.confirmPassword')}</Form.Label>
          <Form.Control
            required
            type="password"
            placeholder={t('register.confirmPlaceholder')}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>




        <Button type="submit" variant="primary" className="mt-3">
          {t('register.submit')}  
        </Button>
      </Form>

      <Row className="py-3">
        <Col>
          {t('register.existingCustomer')} <Link to={redirect ? `/login?redirect=${redirect}` : '/login'}>{t('register.login')}</Link>
        </Col>
      </Row>
    </FormContainer>
  );
}





export default RegisterScreen;